import "./login.css";

import { Descope, useSession } from "@descope/react-sdk";
import { useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocale } from "@/hooks/use-locale";

export default function Login() {
    const navigate = useNavigate();
    const { search, hash, state } = useLocation();
    const { isAuthenticated } = useSession();
    const locale = useLocale();

    const [isFlowReady, setIsFlowReady] = useState(false);

    // Filter out common intermediate log in-related query parameters after log in
    const searchParameters = new URLSearchParams(search);
    ["code", "token", "descope-login-flow"].forEach((key) => {
        searchParameters.delete(key);
    });
    const sanitizedSearchParameters = searchParameters.toString() ? `?${searchParameters.toString()}` : "";
    const successPath = `${state?.path || "/"}${sanitizedSearchParameters}${hash}`;

    useEffect(() => {
        if (isAuthenticated) {
            navigate(successPath);
        }
    }, [isAuthenticated, navigate, successPath]);

    // Hide before paint to avoid a flash when locale changes.
    useLayoutEffect(() => {
        setIsFlowReady(false);
    }, [locale]);

    return (
        <>
            <div className={"login_page"}>
                <div className={"login_center"} style={{ display: isFlowReady ? "block" : "none" }}>
                    <Descope
                        // key= forces a remount on locale change — Descope does not pick up locale
                        // updates on an existing flow instance, so a fresh mount is required.
                        key={locale}
                        flowId={"sign-in-basic"}
                        form={{ locale }}
                        onSuccess={() => navigate(successPath)}
                        onReady={() => setIsFlowReady(true)}
                    />
                </div>
            </div>
        </>
    );
}
